import {LitElement, html, css} from "lit";
import '@material/mwc-select';

class CbarDropdown extends LitElement {
  static get styles() {
    return css`
      :host {
        display: block;
      }

      mwc-select {
        width: 100%;
          --mdc-select-error-color: var(--cbar-select-error-color, var(--cbar-sys-color-error));
          --mdc-select-idle-line-color: var(--cbar-select-idle-line-color, var(--cbar-sys-color-on-surface-variant));
          --mdc-select-hover-line-color: var(--cbar-select-hover-line-color, var(--cbar-sys-color-on-surface));
          --mdc-select-outlined-idle-border-color: var(--cbar-select-outlined-idle-border-color, var(--cbar-sys-color-outline));
          --mdc-select-outlined-hover-border-color: var(--cbar-select-outlined-hover-border-color, var(--cbar-sys-color-on-surface, black));
          --mdc-select-outlined-disabled-border-color: var(--cbar-select-outlined-disabled-border-color, var(--cbar-sys-color-on-surface, black));
          --mdc-select-fill-color: var(--cbar-select-fill-color, var(--cbar-sys-color-surface-container-highest, transparent));
          --mdc-select-disabled-fill-color: var(--cbar-select-disabled-fill-color, var(--cbar-sys-color-on-surface));
          --mdc-select-ink-color: var(--cbar-select-ink-color, var(--cbar-sys-color-on-surface, black));
          --mdc-select-label-ink-color: var(--cbar-select-label-ink-color, var(--cbar-sys-color-primary, #004CA2));
          --mdc-select-focused-label-color: var(--cbar-select-focused-label-color, var(--cbar-sys-color-primary, #004CA2));
          --mdc-select-disabled-ink-color: var(--cbar-select-disabled-ink-color, var(--cbar-sys-color-on-surface-variant, grey));
          --mdc-select-dropdown-icon-color: var(--cbar-select-dropdown-icon-color, var(--cbar-sys-color-on-surface-variant, grey));
          --mdc-select-focused-dropdown-icon-color: var(--cbar-select-focused-dropdown-icon-color, var(--cbar-sys-color-on-surface-variant, grey));
          --mdc-select-disabled-dropdown-icon-color: var(--cbar-select-disabled-dropdown-icon-color, var(--cbar-sys-color-on-surface));
          --mdc-select-error-dropdown-icon-color: var(--cbar-select-error-dropdown-icon-color, var(--cbar-sys-color-error));
      }

      mwc-list-item[disabled] {
        --mdc-theme-text-primary-on-background: var(--cbar-disabled-text-color, #858585);
      }
    `;
  }

  render() {
    return html`
      <mwc-select ?required=${this.required} .outlined=${this.outlined} label="${this.label}" validationMessage="${this.validationMessage}" value="${this.value}" .fixedMenuPosition=${this.fixedMenuPosition} @change=${this.onChange} ?disabled="${this.disabled}">
        ${this.items.map(item => html`<mwc-list-item value="${item.id}" .disabled=${item.disabled}>${item.title}</mwc-list-item>`)}
      </mwc-select>
    `;
  }

  static get properties() {
    return {
      label: {
        type: String
      },
      items: {
        type: Array,
      },
      value: {
        type: String,
      },
      outlined: {
        type: Boolean,
      },
      dense: {
        type: Boolean,
        reflect: true,
      },
      fixedMenuPosition: {
        type: Boolean,
      },
      required: {
        type: Boolean
      },
      disabled: {
        type: Boolean
      },
      validationMessage : {
        type: String
      }
    };
  }

  constructor() {
    super();

    this.items = [];
    this.outlined = false;
    this.dense = false;
    this.value = '';
    this.fixedMenuPosition = false;
    this.required = false;
    this.disabled = false;
    this.validationMessage = ""
  }

  updated(changedProperties) {
    super.updated(changedProperties);

    if (changedProperties.has('dense')) {
      requestAnimationFrame(() =>
        this.dense
          ? this.applyDenseStylesheet()
          : this.disableDenseStylesheet()
      );
    }
  }

  get dropdown() {
    return this.shadowRoot.querySelector('mwc-select');
  }

  get denseStylesheetId() {
    return 'denseStylesheet';
  }

  getExistingDenseStylesheet() {
    return this.dropdown.shadowRoot.querySelector(`#${this.denseStylesheetId}`);
  }

  disableStylesheet(stylesheet) {
    stylesheet.setAttribute('media', 'max-width: 1px');
  }

  enableStylesheet(stylesheet) {
    stylesheet.removeAttribute('media');
  }

  applyDenseStylesheet() {
    // Hack to allow "dense" styling of the dropdown's textfield
    const existingStylesheet = this.getExistingDenseStylesheet()
    if (existingStylesheet) {
      return this.enableStylesheet(existingStylesheet);
    }

    const stylesheet = document.createElement('style');
    stylesheet.id = this.denseStylesheetId;

    const css = `
      .mdc-select__anchor {
        height: 40px !important;

        /* This ensures that the textinput in filled dropdowns fits */
        align-items: flex-end !important;
      }

      .mdc-select--outlined .mdc-floating-label--float-above {
        /* Adjust position of the label for outlined dropdowns */
        transform: translateY(-29.5px) !important;
      }
    `;

    stylesheet.appendChild(document.createTextNode(css));

    this.dropdown.shadowRoot.appendChild(stylesheet);
  }

  disableDenseStylesheet() {
    const existingStylesheet = this.getExistingDenseStylesheet()
    if (!existingStylesheet) {
      return;
    }

    this.disableStylesheet(existingStylesheet);
  }

  onChange(e) {
    this.value = e.target.value;

    this.dispatchEvent(new CustomEvent('change'));
  }

  validate(){
    return this.dropdown.reportValidity();
  }
}

window.customElements.define('cbar-dropdown', CbarDropdown);
